package com.shadowings.gero.data.lessons.chapter4

import androidx.compose.foundation.layout.Row
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_ad_esempio_ecco_uno_dei_cartigli_del_famosissimo_tutankhamon
import gero.composeapp.generated.resources.exp_content_ah_giusto_l_anticipazione_di_rispetto
import gero.composeapp.generated.resources.exp_content_all_inizio_troviamo_re_dell_alto_e_basso_egitto
import gero.composeapp.generated.resources.exp_content_e_poi_all_interno_uhm_imn_twt_ankh
import gero.composeapp.generated.resources.exp_content_facciamo_una_pausa_dalla_grammatica_e_torniamo_ai_cartigli
import gero.composeapp.generated.resources.exp_content_i_cartigli_erano_riservati_alle_divinita_inclusi_i_faraoni
import gero.composeapp.generated.resources.exp_content_il_nome_di_amun_scritto_all_inizio_ma_l_ordine_corretto_alla_fine
import gero.composeapp.generated.resources.exp_content_il_primo_nome_nel_cartiglio_il_nome_di_incoronazione
import gero.composeapp.generated.resources.exp_content_per_ultimo_un_epiteto_come_eletto_da_o_amato_da
import gero.composeapp.generated.resources.exp_content_prima_del_cartiglio_in_apposizione_si_trova_il_titolo
import gero.composeapp.generated.resources.exp_content_segue_il_nome_di_nascita_profano_del_faraone
import gero.composeapp.generated.resources.exp_content_lezione_finita_cartigli
import gero.composeapp.generated.resources.exp_content_twt_ankh_imn_tutankhamon
import gero.composeapp.generated.resources.exp_title_cartigli
import gero.composeapp.generated.resources.exp_title_lezione_completata
import gero.composeapp.generated.resources.quiz_cartigli_due_nomi_in_cartiglio
import gero.composeapp.generated.resources.quiz_cartigli_epiteto_solo_nomen
import gero.composeapp.generated.resources.quiz_cartigli_tutankhamon_praenomen
import gero.composeapp.generated.resources.quiz_cartigli_tutankhamon_significato
import gero.composeapp.generated.resources.quiz_cartigli_tutti_cinque_nomi

fun getCartigliContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_cartigli,
            content = Res.string.exp_content_facciamo_una_pausa_dalla_grammatica_e_torniamo_ai_cartigli,
            face = Faces.Happy
        ),
        ExplanationContent(
            title = Res.string.exp_title_cartigli,
            content = Res.string.exp_content_i_cartigli_erano_riservati_alle_divinita_inclusi_i_faraoni,
            face = Faces.Serious
        ),
        ExplanationContent(
            title = Res.string.exp_title_cartigli,
            content = Res.string.exp_content_prima_del_cartiglio_in_apposizione_si_trova_il_titolo,
            face = Faces.Idle
        ),
        ExplanationContent(
            title = Res.string.exp_title_cartigli,
            content = Res.string.exp_content_il_primo_nome_nel_cartiglio_il_nome_di_incoronazione,
            face = Faces.Idle
        ),
        ExplanationContent(
            title = Res.string.exp_title_cartigli,
            content = Res.string.exp_content_segue_il_nome_di_nascita_profano_del_faraone,
            face = Faces.Idle
        ),
        ExplanationContent(
            title = Res.string.exp_title_cartigli,
            content = Res.string.exp_content_per_ultimo_un_epiteto_come_eletto_da_o_amato_da,
            face = Faces.Serious
        ),
        ExplanationContent(
            title = Res.string.exp_title_cartigli,
            content = Res.string.exp_content_ad_esempio_ecco_uno_dei_cartigli_del_famosissimo_tutankhamon,
            face = Faces.Happy,
            composable = {
                Row {
                    MdCWord("M23-L2", rtl = false, cart = false)
                    MdCWord("M17-Y5:N35-G43B-S34", rtl = false, cart = true)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_cartigli,
            content = Res.string.exp_content_all_inizio_troviamo_re_dell_alto_e_basso_egitto,
            face = Faces.Happy,
            composable = {
                Row {
                    MdCWord("M23-L2", rtl = false, cart = false)
                    MdCWord("M17-Y5:N35-G43B-S34", rtl = false, cart = true)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_cartigli,
            content = Res.string.exp_content_e_poi_all_interno_uhm_imn_twt_ankh,
            face = Faces.Surprised,
            composable = {
                Row {
                    MdCWord("M23-L2", rtl = false, cart = false)
                    MdCWord("M17-Y5:N35-G43B-S34", rtl = false, cart = true)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_cartigli,
            content = Res.string.exp_content_ah_giusto_l_anticipazione_di_rispetto,
            face = Faces.Happy,
            composable = {
                Row {
                    MdCWord("M23-L2", rtl = false, cart = false)
                    MdCWord("M17-Y5:N35-G43B-S34", rtl = false, cart = true)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_cartigli,
            content = Res.string.exp_content_il_nome_di_amun_scritto_all_inizio_ma_l_ordine_corretto_alla_fine,
            face = Faces.Serious,
            composable = {
                Row {
                    MdCWord("M23-L2", rtl = false, cart = false)
                    MdCWord("M17-Y5:N35-G43B-S34", rtl = false, cart = true)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_lezione_completata,
            content = Res.string.exp_content_twt_ankh_imn_tutankhamon,
            face = Faces.Perfect
        ),
        ExplanationContent(
            title = Res.string.exp_title_lezione_completata,
            content = Res.string.exp_content_lezione_finita_cartigli,
            face = Faces.Happy
        )
    )
}

fun getCartigliQuizContent(): List<IQuizContent> {
    return listOf(
        TrueFalseContent(
            text = Res.string.quiz_cartigli_tutti_cinque_nomi,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_cartigli_due_nomi_in_cartiglio,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_cartigli_epiteto_solo_nomen,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_cartigli_tutankhamon_praenomen,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_cartigli_tutankhamon_significato,
            correct = true
        )
    )
}

